module.exports = __webpack_public_path__ + "img/app-item-uploading.76db9160.svg";